<app-modal-header title="Add Warehouse Sensor" (closeModal)="closeDialog()"></app-modal-header>
<div class="form-holder">
    <main-dynamic-form
            class="py-5"
            [fields]="sensorFields"
            [loading]="loading"
            [showRequiredTitle]="false"
            loadingMessage="Saving your data, please wait..."
            [confirmFirst]="true"
            confirmMessage="You are about to save your data. Do you want to continue?"
            [form]="supportForm"
            (submit)="submitForm($event)">
    </main-dynamic-form>
</div>
